// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"66":"textbanner","108":"infobox","298":"infoboxcomparison","670":"credits","675":"infoboxvideo"}[chunkId] + "." + {"66":"571dfa28","108":"020770da","298":"8a80cc61","670":"0107102e","675":"27f75c20"}[chunkId] + ".css";
};